<template lang="">
    <div style="height:100vh">
        <h1>Mall</h1>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
}
</script>
<style lang="">
    
</style>